import React from 'react';
export class HelloMessage extends React.Component {
  render() {
    const { name } = this.props;

    return (
      <div>
        Hello {name}
      </div>
    );
  }
}

